import React from 'react';
import { useFormik } from 'formik';
import { postDataToTheServer } from '../../../../helpers/api';
import AppURL from '../../../../constants/AppURL';
import { ToastSuccess, ToastWarning } from '../../../../constants/Toast';
import Container from '../../../../constants/Container';
import SecHeading from '../../../../constants/SecHeading';
import { Grid } from '@mui/material';
import InputTextBox from '../../../../constants/InputTextBox';
import { handleChangePhone, handleNepaliInputChange, handleSelectBox } from '../../../../helpers/handleChange';
import { EndBaseLine } from '../../../../constants/AppSpace';
import { Button } from '../../../../constants/Button';
import SelectInputBox from '../../../../constants/SelectInputBox';
import { YesNoOptions } from '../../../../constants/Options';
import NepaliInputBox from '../../../../constants/NepaliInputBox';

interface ItemStoreFormViewProps {
    handleFormSuccess: () => void;
}
const ItemStoreCreateView: React.FC<ItemStoreFormViewProps> = ({ handleFormSuccess }) => {
    const initialValues = {
        store_name: "",
        store_name_nep: "",
        store_code: "",
        email: "",
        phone_no: "",
        address: "",
        address_nep: "",
        status: "",
        list: "",
        remarks: "",
    };
    const { values, errors, touched, setFieldValue, isSubmitting, handleBlur, handleChange, handleSubmit } = useFormik({
        initialValues,
        // validationSchema: toleValidationSchema,
        enableReinitialize: true,
        onSubmit: async (values, action) => {
            const formData = new FormData();
            Object.keys(values).forEach((key) => {
                const value = (values as Record<string, any>)[key];
                if (key === 'status') {
                    formData.append("status", value === "1" ? "1" : "0");
                } else if (value !== undefined && value !== null && value !== "") {
                    formData.append(key, value);
                }
            });
            try {
                await postDataToTheServer(AppURL.InventoryURL + 'inventory/product/item/store/create/list/view/', formData).then((res) => {
                    if (res?.status === 201) {
                        handleFormSuccess();
                        action.resetForm();
                        ToastSuccess({ message: res?.message });
                    } else if (res?.status === 400) {
                        ToastWarning({ message: res?.message });
                    }
                    else {
                        ToastWarning({ message: "Some Issue" });
                    }
                });
            } catch (error) {
                console.log(error);
            }
        },
    });
    return (
        <Container padding={true}>
            <form onSubmit={handleSubmit}>
                <SecHeading type='add' label='Store Add' />
                <Grid container columnSpacing={3} rowSpacing={0.8}>
                    <Grid item xl={6} lg={6} sm={6} md={6} xs={12}>
                        <InputTextBox
                            type='text'
                            name='store_name'
                            label='Store Name'
                            handleChange={handleChange}
                            value={values.store_name}
                            error={errors.store_name}
                            handleBlur={handleBlur}
                            touched={touched.store_name}
                            required={true}
                            placeholder='Enter Store Name'
                        />
                    </Grid>
                    <Grid item xl={6} lg={6} sm={6} md={6} xs={12}>
                        <NepaliInputBox
                            label='Store Name(Nepali)'
                            name='store_name_nep'
                            value={values.store_name_nep}
                            handleChange={(e) => handleNepaliInputChange(e, { setFieldValue, name: 'store_name_nep' })}
                            required={true}
                            handleBlur={handleBlur}
                            error={errors.store_name_nep}
                            placeholder='Enter Store Name(Nepali)'
                            touched={touched.store_name_nep}
                        />
                    </Grid>

                    <Grid item xl={6} lg={6} sm={6} md={6} xs={12}>
                        <InputTextBox
                            type='text'
                            name='store_code'
                            label='Store Code'
                            handleChange={handleChange}
                            value={values.store_code}
                            error={errors.store_code}
                            handleBlur={handleBlur}
                            touched={touched.store_code}
                            required={true}
                            placeholder='Enter Store code'
                        />
                    </Grid>
                    <Grid item xl={6} lg={6} sm={6} md={6} xs={12}>
                        <InputTextBox
                            type='email'
                            name='email'
                            label='E-mail'
                            handleChange={handleChange}
                            value={values.email}
                            error={errors.email}
                            handleBlur={handleBlur}
                            touched={touched.email}
                            required={false}
                            placeholder='Enter Email'
                        />
                    </Grid>

                    <Grid item xl={6} lg={6} sm={6} md={6} xs={12}>
                        <InputTextBox
                            type='text'
                            name='phone_no'
                            label='Phone No.'
                            handleChange={(e) => handleChangePhone(e, { setFieldValue, name: 'phone_no' })}
                            value={values.phone_no}
                            error={errors.phone_no}
                            handleBlur={handleBlur}
                            touched={touched.phone_no}
                            required={false}
                            placeholder='Enter Phone No.'
                        />
                    </Grid>

                    <Grid item xl={6} lg={6} sm={6} md={6} xs={12}>
                        <InputTextBox
                            type='text'
                            name='address'
                            label='Store Address'
                            handleChange={handleChange}
                            value={values.address}
                            error={errors.address}
                            handleBlur={handleBlur}
                            touched={touched.address}
                            required={false}
                            placeholder='Enter Address'
                        />
                    </Grid>
                    <Grid item xl={6} lg={6} sm={6} md={6} xs={12}>
                        <NepaliInputBox
                            label='Store Address(Nepali)'
                            name='address_nep'
                            value={values.address_nep}
                            handleChange={(e) => handleNepaliInputChange(e, { setFieldValue, name: 'address_nep' })}
                            required={false}
                            handleBlur={handleBlur}
                            error={errors.address_nep}
                            placeholder='Enter Store addres(Nepali)'
                            touched={touched.address_nep}
                        />
                    </Grid>
                    <Grid item xl={6} lg={6} sm={6} md={6} xs={12}>
                        <InputTextBox
                            type='text'
                            name='list'
                            label='Store List'
                            handleChange={handleChange}
                            value={values.list}
                            error={errors.list}
                            handleBlur={handleBlur}
                            touched={touched.list}
                            required={true}
                            placeholder='dress, pen. pencil, etc..'
                        />
                    </Grid>
                    <Grid item xl={6} lg={6} sm={6} md={6} xs={12}>
                        <SelectInputBox
                            label='Active'
                            options={YesNoOptions}
                            optionSelect={(name, selectedOption) => {
                                handleSelectBox({ setFieldValue, name, value: selectedOption })
                            }
                            }
                            required={true}
                            placeholder='Select Active/Inactive'
                            name='status'
                            handleBlur={() => {
                                handleBlur({ target: { name: 'status' } });
                            }}
                            value={values.status}
                            touched={touched.status}
                            errors={errors.status}
                        />
                    </Grid>
                    <Grid item xl={6} lg={6} sm={6} md={6} xs={12}>
                        <InputTextBox
                            type='text'
                            name='remarks'
                            label='Remarks'
                            handleChange={handleChange}
                            value={values.remarks}
                            error={errors.remarks}
                            handleBlur={handleBlur}
                            touched={touched.remarks}
                            required={false}
                            placeholder='Enter Remarks'
                        />
                    </Grid>

                    <Grid item xl={12} lg={12} sm={12} md={12} xs={12}>
                        <EndBaseLine top={18}>
                            <Button btn_type='save' type='submit' el='button' />
                        </EndBaseLine>
                    </Grid>
                </Grid>
            </form>

        </Container>
    )
}

export default ItemStoreCreateView